import axios from "~/plugins/axios";

const baseUrl = "/web_api/v1/mortgage";

export default {
  find(mortgageId, includes = []) {
    return axios.get(`${baseUrl}/${mortgageId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  detailedSearch(query, secondQuery, type, limit, includes = []) {
    return axios.post("/web_api/v1/mortgage/detailed_search", {
      query,
      second_query: secondQuery,
      type,
      limit,
    }, { params: { include: includes } })
      .then((response) => response.data);
  },
  getMortgagesByFilter(filter) {
    const uri = `${baseUrl}/filtered`;

    return axios.get(uri, {
      params: filter,
    }).then((response) => response.data);
  },
  getByCustomer(customerId, includes = []) {
    return axios.get(`${baseUrl}/by_customer/${customerId}`, {
      params: {
        include: includes,
      },
    });
  },
  saveMortgage(data) {
    return axios.post(baseUrl, data);
  },
  updateMortgage(mortgageId, data) {
    return axios.put(`${baseUrl}/${mortgageId}`, data);
  },
  getListsToCreateOrEdit(mortgageId = null) {
    return axios.get(`${baseUrl}/getListsToCreateOrEdit`, {
      params: {
        mortgage_id: mortgageId,
      },
    })
      .then((response) => response.data);
  },
  getLoanTypes(hdnCode) {
    return axios.get(`${baseUrl}/moneyProvider/loanTypes/${hdnCode}`)
      .then((response) => response.data);
  },
  getHdnCompanyRates(financierAgencyId) {
    return axios.get(`${baseUrl}/hdnCompanyRates/${financierAgencyId}`)
      .then((response) => response.data);
  },
  fetchOfferCoolingOffPeriodDate(offerGivenDate) {
    return axios.get(`${baseUrl}/offerCoolingOffPeriodDate`, {
      params: {
        offerGivenToCustomerDate: offerGivenDate,
      },
    }).then((response) => response.data);
  },
};
